import { useEffect, useMemo, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CustomerService } from "../../../../services/CustomerService";
import { CommonService } from "../../../../services/CommonService";
import { IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";

export const useCustomerFeatures = (changeAlert: ChangeAlertCallbackType) => {
    const [list, setList] = useState([]);
    const [type, setType] = useState("");
    const [search, setSearch] = useState("");
    const [active, setActive] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const [disabledAdd, setDisabledAdd] = useState(false);
    const [listStatus, setListStatus] = useState([]);
	const [catalog, setCatalog ] = useState(Array<{v:"", k: ""}>)
    const [loading, setLoading] = useState(false);

    const commonService = useRef<CommonService>();
    const customerService = useRef<CustomerService>();

    const init = async () => {
        setSearch("");
        setList([])
        setListStatus([])
        setActive(false)
        setDisabled(true)
    }

    const getCatalog = async (type: string) => {
        setLoading(true);
        setType(type)
		
        let data = {
            catalog: {
              id: 'cancelation.type',
              filters: type === 'cancel' ? [{ type: 'cancel', 'metadata.requester': 'compliance' }] : [{ type: 'block' }],
            },
        };

        const response = await commonService.current.getCatalog(data);
        if(response?.data?.response === 'OK'){
            setCatalog(response.data.catalog)
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, 'error', 'Ocurrió un error, ' + response.data.message);
        }
    };

    const find = async () => {
        setLoading(true);
        const response = await customerService.current.customerSearch(search);
        if(response?.data?.response === 'OK'){
            let data = response.data.widget[0].data.content;
            let filterList = []
            if(type === 'cancel'){
                filterList = data.filter((item) => {
                    return item.status !== "Inactivo" ?? item               
                })
            }
            if(type === 'block'){
                filterList = data.filter((item) => {
                    return (item.status !== "Inactivo" && item.status !== "Bloqueado") ?? item               
                })
            }
            setList(filterList);
            setActive(true)
            setLoading(false);
        } else {
			setList([]);
            setLoading(false);
            changeAlert(true, 'error', response.data.message);
        }
    };

    const onSelectFile = async (e) => {
        let csv = e.target.files[0];
        if(!csv){
          changeAlert(true, 'error', "Error en selección de archivo");
        } else if(csv.type !== "text/csv"){
            changeAlert(true, 'error', "Error: El tipo de archivo permitido es CSV");
        } else {
            let reader = new FileReader();
          
            if(csv){
                reader.readAsDataURL(csv);
                reader.onload = ((binding) => {
                    return async () => {
                        setLoading(true);
                        let parts = reader.result.toString().split(',')[1];
                        let props = {
                            uuid: 'uuid',
                            reason: 'reason',
                            comment: 'comment'
                        }
                        const response = await commonService.current.csvToJson(parts, props);
                        if(response?.data?.response === 'OK'){
                            let content = response.data.content
                            if(type === 'block'){
                                content = response.data.content.map((item) => {
                                    item["action"] = "block" 
                                    return item
                                })
                            }
							let total = listStatus.concat(content)
							let data = Object.values(total.reduce((acc, cur) => Object.assign(acc,{[cur.customer.uuid]: cur}), {}))
							
							validate(data, "")
							setListStatus(data)
                            setLoading(false);
                        } else {
                            setList([]);
                            setLoading(false);
                            changeAlert(true, 'error', response.data.message);
                        }
                    }}
                )(this);
            }
        }
    }

    const addToCancel = (row) => {
		let l = list
        const cleanList = l.filter((item) => {
          	return item.uuid !== row.uuid
        })

        const verify = listStatus.filter((item) => {
          	return item.customer.uuid === row.uuid
        })
        if(verify.length === 0){
			let data = {
				customer: {
					uuid: row.uuid,
					name: row.name
				},
				reason: "",
			};
            if(type === 'block'){
                data['action'] = 'block'
            }
			validate([...listStatus, data], "")
			setListStatus([...listStatus, data])
		
			if([...listStatus, data].length < 50){
				setDisabledAdd(false)
			} else {
				setDisabledAdd(true)
			}
        }
        setList(JSON.parse(JSON.stringify(cleanList)))
    }

	const deleteCustomer = async (uuid) => {  
		const cleanList = listStatus.filter((item) => {
		  return item.customer.uuid !== uuid
		})
		if(cleanList.length < 50){
		  	setDisabledAdd(false)
		}else{
		  	setDisabledAdd(true)
		}
		validate(cleanList, "")
		setListStatus(JSON.parse(JSON.stringify(cleanList)))
	}
	
	const onSelectReason = (event, uuid) => {
		let value = event.target.value as string;
		let err = ""
		const data = listStatus.map((item) => {
			if(item.customer.uuid === uuid){
				item.reason = Number(value)
			}
			return item
		})
		
		if (Number(value) > -1) {
		  	err = ""
		} else {
		  	err = "Dato obligatorio"
		}
	
		validate(data, err)
		setListStatus(data)
	};

    const addComment = (event, uuid) => {
		let value = event.target.value as string;
		const data = listStatus.map((item) => {
			if(item.customer.uuid === uuid){
				item.comment = value
			}
			return item
		})
        validate(data, "")
		setListStatus(data)
	};	
	
	const validate = async (f, er) => {
		for (let i = 0; i < f.length; i++) {
			if(f[i]['customer']['uuid'] && f[i]['reason'] && f[i]['comment'] && !er){
				setDisabled(false);
			} else {
				setDisabled(true);
				break
			}      
		}
        if(f.length === 0){
            setDisabled(true)
        }
	}
	
	const send = async () => {
		setLoading(true);
		for (let i = 0; i < listStatus.length; i++) {
            delete listStatus[i].customer.name      
		}

        const response = await customerService.current[type === 'cancel' ? 'customerCancel' : 'customerBlockUnblock'](listStatus);
        if(response?.data?.response === 'OK'){
			await init()
			changeAlert(true, "success", response.data.message);
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, 'error', response.data.message);
        }
	};

	const colapse = () => {
		if (active) {
		  	setActive(false);
		} else {
		  	setActive(true);
		}
	};

	const changeText = (e) => {
		setSearch(e.target.value);
	};

    useEffect(() => {
        customerService.current = new CustomerService(changeAlert)
        commonService.current = new CommonService(changeAlert)
        init()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => row.name, name: "Nombre", width:"25%", wrap: true, sortable: true },
            { selector: (row) => row.email, name: "Email", width:"30%", wrap: true, sortable: true },
            { selector: (row) => row.uuid, name: "UUID", width:"35%", wrap: true, sortable: true },
            { cell: (row) => {
				return (
					<IconButton disabled={disabledAdd} title={`Agregar`} edge="end" onClick={addToCancel.bind(this, row)}>
					<Add/>
					</IconButton>
				);
				}, width: "10%", sortable: true,
            }
        ]
        return columns

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addToCancel])

    return { getCatalog, find, onSelectFile, deleteCustomer, onSelectReason, send, changeText, addComment, columns: calculateColumns, loading, active, disabled, catalog, search, list, listStatus, disabledAdd, colapse }

}
